export const branding = {
  shortName: 'PRO-PAMPA',
  tagline: 'Manejo e Conservação da Fauna',
  fullName: 'Associação Gaúcha de Manejo e Conservação da Fauna',
  legalName: 'PRO-PAMPA: Associação Gaúcha de Manejo e Conservação da Fauna',
  logoSrc: '/logo-pro-pampa.png',
  colors: {
    primary: '#1b4332',
    primaryLight: '#2d6a4f',
    primaryDark: '#081c15',
    accent: '#bc6c25',
    surface: '#f4f7f5',
    sidebar: '#ffffff',
  },
} as const;
